import { Vector3 } from "three";

import { ControllerStrategy } from "../../strategy";

export class LookAtFriendlyTransitionControllerStrategy extends ControllerStrategy {
  private pos: Vector3 = new Vector3();
  private target: Vector3 = new Vector3();
  private delta: Vector3 = new Vector3();

  private startPos: Vector3 = new Vector3();
  private endPos?: Vector3;
  private transElapsedS = 0;
  private transDurationS = 2;

  protected deltaT = {
    slow: 8,
    fast: 2,
  };

  update(deltaS: number, _gameTimeDelta: number, _frameNum?: number) {
    if (!this.registered) {
      console.error("no controls registered");
      return;
    }

    const controls = this.registered.controls;
    if (!controls) return;

    if (this.endPos) {
      controls.getPosition(this.pos);
      controls.getTarget(this.target);

      this.delta.copy(this.pos);

      let t = this.transElapsedS / this.transDurationS;
      t = t * t * (3 - 2 * t);

      if (this.transElapsedS < this.transDurationS) {
        this.pos.lerpVectors(this.startPos, this.endPos, t);
      } else {
        controls.enabled = true;
        this.pos.copy(this.endPos);

        this.endPos = undefined;
      }

      this.delta.subVectors(this.pos, this.delta);
      this.target.add(this.delta);

      if (this.registered.state.following) {
        controls.setLookAt(
          this.pos.x,
          this.pos.y,
          this.pos.z,
          this.target.x,
          this.target.y,
          this.target.z,
          true
        );
      }

      this.transElapsedS += deltaS;
    } else {
      this.transElapsedS = 0;
    }
  }

  protected setupTransition(endPos: Vector3, duration?: number) {
    if (!this.registered) return;

    const { controls, contextRef } = this.registered;
    if (!controls) return;

    if (this.endPos && endPos.distanceTo(this.endPos) < 0.1) {
      return;
    }

    // controls.getPosition(this.pos);
    if (this.pos.distanceTo(endPos) < 0.1) {
      return;
    }

    if (!duration) {
      duration = contextRef.state.actionCamTransDuration;
    }

    this.transDurationS = duration;

    controls.enabled = false;
    controls.getPosition(this.startPos);
    this.endPos = endPos;
  }

  protected cancelTransition() {
    this.endPos = undefined;
  }
}
